import React from 'react';

export default () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0007 27.2266L3.7207 18.9466L7.49404 15.1733L12.0007 19.6933L25.174 6.50659L28.9474 10.2799L12.0007 27.2266Z"
        fill="#E8B30D"
      />
    </svg>
  );
};
